import { type AlertConfig, Box } from "@prismicio/editor-ui"
import { useState } from "react"

import { sidePanelPadding, sidePanelWidth } from "../../documentLayout"
import { useDocument } from "../../DocumentProvider"
import { SettingsMenu } from "../SettingsMenu"
import { CreateButton } from "./CreateButton"
import { PublishButton } from "./PublishButton"
import { SaveButton } from "./SaveButton"
import { showUnpublish, UnpublishButton } from "./UnpublishButton"

export type PendingAction =
  | undefined
  | "create"
  | "save"
  | "publish"
  | "release"
  | "unpublish"

export interface PendingActionProps {
  pendingAction: PendingAction
  onPendingActionChange: (action: PendingAction) => void
}

export function HeaderButtons() {
  return (
    <Box
      display="flex"
      gap={8}
      alignItems="flex-start"
      width={sidePanelWidth}
      flexShrink={0}
      padding={{ left: sidePanelPadding("right").left }}
    >
      <Buttons />
      <SettingsMenu />
    </Box>
  )
}

function Buttons() {
  const { data, type } = useDocument()

  const [pendingAction, onPendingActionChange] = useState<PendingAction>()

  const buttonProps = {
    pendingAction,
    onPendingActionChange,
  }

  if (type === "existing") {
    const primaryButton = showUnpublish(data.version.status) ? (
      <UnpublishButton key="unpublish" {...buttonProps} />
    ) : (
      <PublishButton key="publish" {...buttonProps} />
    )

    return (
      <>
        <SaveButton {...buttonProps} />
        {primaryButton}
      </>
    )
  }

  return <CreateButton {...buttonProps} />
}

interface actionAlertProps {
  action: NonNullable<PendingAction>
  showAlert: (config: AlertConfig) => void
  onRetry: () => void
}
export function actionAlert(props: actionAlertProps) {
  const { action, showAlert, onRetry } = props

  showAlert({
    title: `Oops! We were unable to ${action} your document.`,
    subtitle: `We encountered an error while trying to ${action} your document. Please contact our support team if this issue persists.`,
    onRetry: onRetry,
  })
}
